module.exports = __webpack_public_path__ + "static/media/VISION-QUICK.eeee8ecc.png";